import { Card, DialogBody, FormGroup, Icon, InputGroup } from "@blueprintjs/core";
import classNames from "classnames";
import React, { useState } from "react";

import { Button, Modal, MultiSelect, Tag } from "../../../../components";
import { TagCreator } from "../../../../components/TagCreator/tag-creator";
import { useSelectTagsPlaybook } from "../../../../components/edit-play/hooks/use-select-tags-playbook";
import { Playbook } from "../../../../types/playbook/playbook";
import styles from "./dialogs.module.scss";

interface EditPlaybookDialogProps {
  show: boolean;
  handleClose: () => void;
  playbook: Playbook;
  handleEditPlaybook: (name: string, tags: any[]) => void;
}

export const EditPlaybookDialog = ({ show, handleClose, playbook, handleEditPlaybook }: EditPlaybookDialogProps) => {
  const [playbookName, setPlaybookName] = useState<string>("");
  const [currentPlaybook, setCurrentPlaybook] = useState(playbook);

  const updatePlaybookTags = (callBack: any) => {
    setCurrentPlaybook((prevState) => callBack(prevState));
  };

  const { tagSelect } = useSelectTagsPlaybook({ editingPlaybook: currentPlaybook, updatePlaybookTags });

  /** Tag Creator */
  const [tagCreatorOpen, setTagCreatorOpen] = useState(false);
  const showTagCreator = () => {
    setTagCreatorOpen(true);
  };
  const hideTagCreator = () => {
    setTagCreatorOpen(false);
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") {
      finishEditingName();
    }
  };

  const finishEditingName = () => {
    if (playbookName.length > 0) {
      handleEditPlaybook(playbookName, currentPlaybook.tags);
      setPlaybookName("");
      handleClose();
    } else {
      handleEditPlaybook(playbook.title, currentPlaybook.tags);
      setPlaybookName("");
      handleClose();
    }
  };

  const handleCancel = () => {
    setPlaybookName("");
    handleClose();
  };

  return (
    <Modal
      title="Edit Playbook"
      isOpen={show}
      onClose={handleCancel}
      actions={[
        <Button minimal={true} text="Cancel" onClick={handleCancel} key={2} />,
        <Button intent="success" text="Save" onClick={finishEditingName} key={1} />,
      ]}
    >
      <DialogBody>
        <Card className={classNames(styles.formContainer)}>
          <FormGroup>
            <InputGroup
              placeholder={playbook.title}
              leftIcon="edit"
              value={playbookName}
              onChange={(e) => setPlaybookName(e.target.value)}
              onKeyDown={handleKeyDown}
              className={styles.input}
              autoFocus
            />
          </FormGroup>
          <FormGroup inline className={classNames(styles.tagMultiSelect)}>
            <MultiSelect
              {...tagSelect}
              fill
              placeholder="Select Tags"
              tagRenderer={(tag) => (
                <div data-color={tag.color} data-text-color={tag.textColor}>
                  {tag.name}
                </div>
              )}
              tagInputProps={{
                tagProps: (value: any) => {
                  const color: string | undefined = value?.props?.["data-color"];
                  const textColor: string | undefined = value?.props?.["data-text-color"];
                  return { style: { backgroundColor: color, color: textColor }, rightElement: null };
                },
              }}
              itemRenderer={(item) => <Tag tag={item} />}
            />
            <Icon icon="add" onClick={showTagCreator} className={styles.tagCreator} />
          </FormGroup>

          <TagCreator show={tagCreatorOpen} handleClose={hideTagCreator} updatePlay={updatePlaybookTags} />
        </Card>
      </DialogBody>
    </Modal>
  );
};
